(function () {
  'use strict';

  var DEBUG = window.SalepifyYmalPlacementConfig?.debug === true;

  function log(label, error) {
    if (DEBUG) window.console?.warn?.('[Salepify YMAL placement] ' + label, error);
  }

  function place() {
    var slot = null;
    try {
      var items = document.querySelector('cart-drawer .cart-drawer__items');
      if (!items || items.querySelector('.salepify-ymal-placement')) return;

      slot = document.createElement('div');
      slot.className = 'salepify-ymal-placement';
      items.insertAdjacentElement('beforeend', slot);
    } catch (error) {
      log('could not insert placement', error);
      return;
    }

    try {
      window.tlYMAL?.reInsertWidget();
    } catch (error) {
      // bỏ div đi để lần mutation sau thử lại, không thì guard ở trên khoá vĩnh viễn
      try { slot.remove(); } catch (removeError) { log('could not roll back placement', removeError); }
      log('reInsertWidget failed', error);
    }
  }

  function hasProductVariants(product) {
    if (!product) return false;

    if (product.has_only_default_variant === true) return false;
    if (product.has_only_default_variant === false) return true;

    var variants = product.variants || [];
    if (variants.length > 1) return true;
    if (variants.length === 0) return false;

    // Khi product chỉ có 1 variant:
    // Với product không tạo variant, Shopify luôn tự sinh 1 option duy nhất tên là "Title"
    var options = product.options || [];
    if (options.length > 0) {
      var firstOpt = options[0];
      var optName = typeof firstOpt === 'string' ? firstOpt : (firstOpt && firstOpt.name);
      if (optName && optName.toLowerCase() !== 'title') {
        return true;
      }
    }

    var title = (variants[0].title || '').trim().toLowerCase();
    if (title && title !== 'default title') {
      return true;
    }

    return false;
  }

  function hideDefaultTitles() {
    try {
      var items = document.querySelectorAll('.salepify-ymal-item');
      if (!items.length) return;

      var ymalEl = document.querySelector('salepify-ymal');
      var productList = (window.tlYMAL && window.tlYMAL.upsellItemsData) ||
                        (ymalEl && ymalEl.upsellItemsData) || [];

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var label = item.querySelector('.salepify-ymal-variant-label');
        if (!label) continue;

        var productId = item.getAttribute('product-id');
        var product = null;
        for (var j = 0; j < productList.length; j++) {
          if (String(productList[j].id) === String(productId)) {
            product = productList[j];
            break;
          }
        }

        var shouldHide = false;
        if (product) {
          // Check nếu product không có variant thật thì ẩn
          shouldHide = !hasProductVariants(product);
        } else {
          // Fallback nếu data upsellItemsData chưa sẵn sàng
          var text = (label.textContent || '').trim().toLowerCase();
          shouldHide = text === 'default title' || text.indexOf('default') !== -1;
        }

        if (shouldHide && label.style.display !== 'none') {
          label.style.setProperty('display', 'none', 'important');
        }
      }
    } catch (error) {
      log('hideDefaultTitles failed', error);
    }
  }

  function onDomChange() {
    place();
    hideDefaultTitles();
  }

  function start() {
    try {
      onDomChange();
      // ponytail: observe cả body vì Prestige re-render drawer bằng section rendering; guard ở đầu place() làm mỗi lần chạy gần như free
      new MutationObserver(onDomChange).observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      log('observer setup failed', error);
    }
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  } catch (error) {
    log('bootstrap failed', error);
  }
})();
